import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { Harvest } from "../../database"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import { withBaseModel } from "../extensions/with-base-model"
import SyncableModel from "../../database/SyncableModel"
import { BaseModelStoreProps } from "../base-model-store/base-model-store"
import JalaAnalytic from "../../utils/jala-analytic"

const HarvestStoreProps = {
  ...BaseModelStoreProps
}

/**
 * Model description here for TypeScript hints.
 */
export const HarvestStoreModel = types
  .model("HarvestStore")
  .props(HarvestStoreProps)
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof HarvestStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init() {
      self.initModel();
    },
    async store(data) {
      if (self.rootStore.appStore?.isOffline)
        return this.storeOffline(data)
      return self.storeModel(Harvest, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Harvest added', data);
          return success;
        });
    },
    async storeOffline(data) {
      return self.storeModelOffline(Harvest, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Harvest added', data);
          return success;
        });
    },
    async update(model: SyncableModel, data) {
      if (self.rootStore.appStore?.isOffline)
        return this.updateOffline(model, data)
      return self.updateModel(Harvest, model, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Harvest edited', data);
          return success;
        });
    },
    async updateOffline(model: SyncableModel, data) {
      return self.updateModelOffline(Harvest, model, data)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Harvest edited', data);
          return success;
        });
    },
    async delete(model: SyncableModel) {
      if (self.rootStore.appStore?.isOffline)
        return this.deleteOffline(model)
      return self.deleteModel(Harvest, model)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Harvest deleted', model);
          return success;
        });
    },
    async deleteOffline(model: SyncableModel) {
      return self.deleteModelOffline(Harvest, model)
        .then((success: boolean) => {
          if (success) JalaAnalytic.log('Mobile App: Harvest deleted', model);
          return success;
        });
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type HarvestStoreType = Instance<typeof HarvestStoreModel>
export interface HarvestStore extends HarvestStoreType {}
type HarvestStoreSnapshotType = SnapshotOut<typeof HarvestStoreModel>
export interface HarvestStoreSnapshot extends HarvestStoreSnapshotType {}
export const createHarvestStoreDefaultModel = () => types.optional(HarvestStoreModel, {})
